import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderItem } from 'projects/desktop/src/app/modules/order/data/order-item';
import { Router } from '@angular/router';
import { MatOrderStore } from 'projects/desktop/src/app/modules/order/data/mat-order.store';
import { timer } from 'rxjs';
import { CabinetReport } from 'projects/app-misc/src/app/modules/reports/data/cabinet-report';

@Component({
  selector: 'app-report-cabinets-table',
  templateUrl: './project-complexity-cabinets-table.component.html',
  styleUrls: ['./project-complexity-cabinets-table.component.scss']
})
export class ProjectComplexityCabinetsTableComponent implements OnInit {

  @Input()
  cabReports: CabinetReport[];

  @Input()
  canBeEdited: boolean;

  @Output()
  cabIsEdited = new EventEmitter<void>();

  lastInput: HTMLInputElement

  constructor(
    protected el: ElementRef,
    public router: Router,
    protected matOrderStore: MatOrderStore
  ) {
  }

  ngOnInit(): void {
  }

  roundNum(num: number) {
    return Math.floor(num * 100) / 100
  }

  clickOnEditableCell(event: MouseEvent) {
    // event.srcElement

    const fInput = (this.el.nativeElement.getElementsByClassName('material-input-text') as HTMLInputElement)

    timer(1).subscribe(emit => {
      fInput[0].select()
    })


  }

  clickOnCab(cabName: string) {
    this.matOrderStore.updateSearchQuery(cabName)
    this.router.navigate(['/reports/complexity/cabinets'])
  }

  startEdit(event) {

    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if(tempInputs) {
      timer(1).subscribe(emit => {
        this.lastInput = tempInputs[0] as HTMLInputElement
        this.lastInput.focus()
        this.lastInput.setSelectionRange(0, this.lastInput.value.length);
      })
    }
  }

  onEditComplete(event) {
    this.cabReports.forEach(item => {
      // item.reservedQuantity = parseInt(String(item.reservedQuantity), 10);
      // item.orderedQuantity = parseInt(String(item.orderedQuantity), 10);
      // item.price = parseInt(String(item.price), 10);
    })

    // this.orderIsEdited.next();
  }

  onKeyPress(event) {

    // this.orderIsEdited.next();
  }


}
